import React from "react";
import { Trans, useTranslation } from "react-i18next";

// `labelKey` holds a key name, not copy -- the label carries a <br /> so it is
// resolved through <Trans> at render rather than frozen here at module load.
const GUARANTEES = [
  {
    labelKey: "smallBiz.shippingGuaranteed",
    icon: (
      <>
        <rect x="1" y="6" width="14" height="11" rx="1" />
        <path d="M15 9h4l3 3v5h-7" />
        <circle cx="6" cy="19" r="2" />
        <circle cx="18" cy="19" r="2" />
      </>
    ),
  },
  {
    labelKey: "smallBiz.returnsGuaranteed",
    icon: (
      <>
        <path d="M9 14L4 9l5-5" />
        <path d="M4 9h11a5 5 0 0 1 0 10h-4" />
      </>
    ),
  },
  {
    labelKey: "smallBiz.refundsGuaranteed",
    icon: (
      <>
        <circle cx="12" cy="12" r="9" />
        <text
          x="12"
          y="16.5"
          fontSize="12"
          textAnchor="middle"
          fill="currentColor"
          stroke="none"
          fontWeight="500"
        >
          ₹
        </text>
      </>
    ),
  },
];

const PRESS = [
  "ANI",
  "Business Standard",
  "Hindustan Times",
  "The Tribune",
  "Hans India",
];

/**
 * SupportSmallBiz
 *
 * Owner-voice trust band: guarantee trio + "guaranteed by Wcommerce" +
 * platform-framed press strip.
 */
export default function SupportSmallBiz() {
  const { t } = useTranslation();
  return (
    <section
      className="mx-4 mt-[6px] mb-[18px] p-4 rounded-lg border border-coral/[0.2]"
      style={{
        background: "linear-gradient(160deg,#FEEFEB,#FFFFFF 70%)",
      }}
    >
      <div className="flex gap-[11px] items-start">
        <span
          className="w-[38px] h-[38px] rounded-[10px] flex-none bg-white text-coral-ink grid place-items-center"
          style={{ boxShadow: "0 4px 18px rgba(31,33,46,.08)" }}
        >
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="w-[20px] h-[20px]"
          >
            <path d="M12 21s-7-4.6-9.3-9C1 8.5 3 5 6.5 5 9 5 12 8 12 8s3-3 5.5-3C21 5 23 8.5 21.3 12 19 16.4 12 21 12 21z" />
          </svg>
        </span>
        <div>
          <h2 className="text-[16px] font-[500] text-ink-900 tracking-[-0.01em]">
            {t("smallBiz.title")}
          </h2>
          <p className="text-[11px] text-ink-500 leading-[1.45] mt-[3px]">
            {t("smallBiz.sub")}
          </p>
        </div>
      </div>

      <div className="grid grid-cols-3 gap-[9px] mt-[14px] mb-[10px]">
        {GUARANTEES.map((g, i) => (
          <div
            key={i}
            className="flex flex-col items-center justify-center gap-[6px] text-center bg-white border border-wc-border rounded-md px-[6px] py-[11px] text-[10px] font-[500] text-ink-900 leading-[1.25]"
          >
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="w-[19px] h-[19px] text-verify flex-none"
            >
              {g.icon}
            </svg>
            <Trans i18nKey={g.labelKey} components={[<br />]} />
          </div>
        ))}
      </div>

      <div className="text-[11px] text-ink-700 text-center font-[400]">
        <Trans
          i18nKey="smallBiz.guaranteedBy"
          components={[<b className="text-ink-900 font-[400]" />]}
        />
      </div>

      <div className="mt-[13px] pt-[12px] border-t border-coral/[0.18] text-center">
        <div className="text-[10px] font-[500] text-ink-500">
          {t("smallBiz.poweredBy")}
        </div>
        <div className="flex flex-wrap gap-x-[9px] gap-y-[7px] justify-center mt-[7px]">
          {PRESS.map((p) => (
            <span
              key={p}
              className="text-[9.5px] font-[500] text-ink-500 bg-wc-gray rounded-[5px] px-[8px] py-[4px]"
            >
              {p}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
